var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form", attrs: { novalidate: "" } },
        [
          _c("section-title", {
            attrs: {
              "container-class": "tag-badge-main-info mt-4 mb-4",
              content: "X. Recomendaciones",
              icon: "fas fa-clipboard-list-check"
            }
          }),
          _c(
            "q-tab",
            {
              attrs: {
                "active-tab": _vm.activeTab.index,
                "nav-class": "text-nowrap"
              },
              on: { change: _vm.setTab }
            },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "q-tab-item",
                {
                  key: tab.id,
                  attrs: {
                    active: _vm.activeTab.index === tab.index,
                    "has-error": !tab.valid,
                    lazy: "",
                    tabindex: tab.index,
                    title: tab.name
                  }
                },
                _vm._l(tab.areas, function(area) {
                  return _c(
                    "div",
                    { key: `area-${area.id}` },
                    [
                      _c("answer", {
                        attrs: {
                          "is-read-only": _vm.isReadOnly,
                          valid: tab.valid,
                          value: area
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }